"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Labels = void 0;
const UiKitLite_1 = require("../UiKitLite");
const react_1 = __importStar(require("react"));
const LoremText_1 = require("./LoremText");
const react_2 = require("@chakra-ui/react");
const Labels = () => {
    const [formUse, setFormUse] = (0, react_1.useState)(undefined);
    const plants = 'https://images.unsplash.com/photo-1569135579447-0f74d6f764e9?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=774&q=80';
    const clear = 'https://images.unsplash.com/photo-1471922694854-ff1b63b20054?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2072&q=80';
    return (react_1.default.createElement(react_2.HStack, { align: 'stretch', justify: 'flex-start', w: '100%', spacing: UiKitLite_1.UiKitLite.consistency.buffer },
        react_1.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { width: '450px' },
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Label Text' },
                react_1.default.createElement(LoremText_1.LoremText, null)),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'First Name' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Elvis")),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Last Name', tooltip: "If I found a lucky penny I'd toss it across the bay", tooltipStatus: 'info' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Presley")),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Can Labels wrap any JSX ?' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Collapsible, { status: 'success', summaryString: 'Yes' },
                    react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "They are a great way to structure forms for example."))),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Really ?' },
                react_1.default.createElement(react_2.Image, { boxSize: "200px", objectFit: "cover", borderRadius: UiKitLite_1.UiKitLite.consistency.borderRadius, src: plants, alt: 'Yes' })),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Required Field', showRedAsterisk: true },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "You can optionally request a red asterisk on a label to signal the user should enter a value.")),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'What else are labels useful for ?' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Select, { width: 300, placeholder: 'Open to find out', isLoading: false, value: formUse, onChange: setFormUse, onValueCleared: () => setFormUse(undefined), options: [
                        'Really any kind of vertical layout where you want to label each paragraph',
                        'Forms with inputs',
                        'Modal content',
                        'Sidebar content',
                    ].map(reason => ({ label: reason, value: reason })) })),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Favorite Ice Cream', tooltip: 'Not 🍓 or 🍫 sorry!', tooltipStatus: 'question' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Vanilla")),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Favorite Artist' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Bruce \"The Boss \uD83D\uDC68\u200D\uD83D\uDCBC\" Springsteen"))),
        react_1.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { flex: 1 },
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Here are even more labels' },
                react_1.default.createElement(react_2.HStack, { align: 'center' },
                    react_1.default.createElement(UiKitLite_1.UiKitLite.Tag.Custom, { backgroundColor: 'salmon', borderColor: 'pink', text: '⭐' }),
                    react_1.default.createElement(UiKitLite_1.UiKitLite.Tag.Custom, { backgroundColor: 'salmon', borderColor: 'pink', text: '⭐⭐' }),
                    react_1.default.createElement(UiKitLite_1.UiKitLite.Tag.Custom, { backgroundColor: 'salmon', borderColor: 'pink', text: '⭐⭐⭐' }),
                    react_1.default.createElement(UiKitLite_1.UiKitLite.Tag.Custom, { backgroundColor: 'salmon', borderColor: 'pink', text: '⭐⭐⭐⭐' }),
                    react_1.default.createElement(UiKitLite_1.UiKitLite.Tag.Custom, { backgroundColor: 'salmon', borderColor: 'pink', text: '⭐⭐⭐⭐⭐' }))),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Just to really make it clear' },
                react_1.default.createElement(react_2.Image, { boxSize: "200px", objectFit: "cover", borderRadius: UiKitLite_1.UiKitLite.consistency.borderRadius, src: clear, alt: 'Clear' })),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'That they' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "Can")),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Wrap any content at all' },
                react_1.default.createElement(LoremText_1.LoremText, { color: UiKitLite_1.UiKitLite.consistency.primaryBlue40 })),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Tip, { textLines: ['Labels can also have their content start hidden'], colored: true }),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Dataset Details', collapse: {
                    initially: 'closed',
                } },
                react_1.default.createElement(LoremText_1.LoremText, null)),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Tip, { textLines: ['Or start open'], colored: true }),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Dataset Details', collapse: {
                    initially: 'open',
                } },
                react_1.default.createElement(LoremText_1.LoremText, null)),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Tip, { textLines: [
                    'You can also define content to show when the label is closed.',
                    'This is a good option if you want to show a summary of some longer content',
                ], colored: true }),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Romanes eunt domus', collapse: {
                    initially: 'closed',
                    contentWhenClosed: react_1.default.createElement(LoremText_1.LoremTextSummary, null),
                } },
                react_1.default.createElement(LoremText_1.LoremText, null)),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Hint.Tip, { textLines: [
                    'Even if you have the label initially expanded.',
                    'You can still define summary content for when the user closes the label.',
                ], colored: true }),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Romani ite domum', collapse: {
                    initially: 'open',
                    contentWhenClosed: react_1.default.createElement(LoremText_1.LoremTextSummary, null),
                } },
                react_1.default.createElement(LoremText_1.LoremText, null)))));
};
exports.Labels = Labels;
